import { createFileRoute } from '@tanstack/react-router'
import HistoryListPage from '@/spa/pages/history/HistoryListPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/history/')({
  component: HistoryListPage,
  errorComponent: routeErrorComponent,
})
